import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const MinusCircleIcon = (props) => (
    <SvgIcon viewBox="0 0 20 20" sx={{ height: '20px', width: 'auto', ...props }} >
        <g fill="none">
            <path
                d="M5.83203 10H14.1654"
                stroke="currentColor"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.0013 1.66659C14.6037 1.66659 18.3346 5.39755 18.3346 9.99992C18.3346 14.6023 14.6037 18.3333 10.0013 18.3333C5.39893 18.3333 1.66797 14.6023 1.66797 9.99992C1.66797 5.39755 5.39893 1.66659 10.0013 1.66659Z"
                stroke="currentColor"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="20" height="20" fill="white" transform="matrix(1 0 0 -1 0 20)" />
            </clipPath>
        </defs>
    </SvgIcon>
);

export default MinusCircleIcon;
